const InProgressArrow = (props) => (
  <svg fill='none' height={12} width={13} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='m1.177 4.04 3.2 5.76c.43.775 1.025 1.2 1.68 1.2s1.25-.425 1.68-1.2l3.2-5.76c.405-.735.45-1.44.125-1.995-.325-.555-.965-.86-1.805-.86h-6.4c-.84 0-1.48.305-1.805.86-.325.555-.28 1.265.125 1.995Z'
      fill='currentColor'
    />
  </svg>
);
export default InProgressArrow;
